import Inputmask from 'inputmask';

export default {
	init,
	unmaskElement,
	unmaskAll,
	maskCurrencyElement,
	maskPercentageElement
};

export function init() {
	document.querySelectorAll('.format-ssn').forEach((el) => {
		new Inputmask({ mask: '999-99-9999' }).mask(el as HTMLElement);
	});

	document.querySelectorAll('.format-phone').forEach((el) => {
		new Inputmask({ mask: '(999) 999-9999' }).mask(el as HTMLElement);
	});

	document.querySelectorAll('.format-case-number').forEach((el) => {
		new Inputmask({
			regex: '^([a-zA-Z]{1})([0-9]{3})((?:19|20)\\d{2})([a-zA-Z]{2})([0-9]{6})$',
			casing: 'upper',
		}).mask(el as HTMLElement);
	});

	document.querySelectorAll('.format-sid').forEach((el) => {
		new Inputmask({
			regex: '^([nN]?)([0-9])+$',
			casing: 'upper',
		}).mask(el as HTMLElement);
	});

	document.querySelectorAll('.format-date').forEach((el) => {
		new Inputmask({
			mask: '99/99/9999',
			placeholder: 'MM/DD/YYYY',
		}).mask(el as HTMLElement);
	});

	document.querySelectorAll('.format-currency').forEach((el) => {
		maskCurrencyElement(el);
	});

	document.querySelectorAll('.format-percentage').forEach((el) => {
		maskPercentageElement(el);
	});
}

export function maskCurrencyElement(el: Element) {
	new Inputmask({
		prefix: '$',
		alias: 'currency',
		unmaskAsNumber: true,
		autoUnmask: true,
		removeMaskOnSubmit: true
	}).mask(el as HTMLElement);
}

export function maskPercentageElement(el: Element) {
	new Inputmask({
		suffix: '%',
		alias: 'decimal',
		unmaskAsNumber: true,
		autoUnmask: true,
		removeMaskOnSubmit: true
	}).mask(el as HTMLElement);
}

export function unmaskElement(el: HTMLElement) {
	Inputmask.remove(el);
	
	// Accessing the value triggers the autoUnmask
	// If autoUnmask is not turned on, the unmask() function will need to be called manually.
	let unmaskedVal = $(el).val();
	$(el).val(unmaskedVal);
}

export function unmaskAll() {
	for (let el of $('.format-currency, .format-percentage')) {
		unmaskElement(el);
	}
}

$(init);
